import { FC } from "react";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

import { signupSteps } from "./signupSteps";

export interface IStep {
  label: string;
  slugs: string[]; // all slugs that belong to this step
}

export interface ISimpleProgressStepsProps {
  steps: IStep[];
  currentSlug: string;
  hideLabels?: boolean; // hides the label text for each step
  // onStepClick?: boolean;
}

export const SimpleProgressSteps: FC<ISimpleProgressStepsProps> = ({
  steps = signupSteps,
  currentSlug,
  hideLabels = false,
}) => {
  // Find the index of the current step based on the slug
  const currentStepIndex = steps.findIndex((step) => step.slugs.includes(currentSlug));

  // Calculate progress percentage for each step
  const getProgress = (stepIndex: number): "0%" | "100%" => (stepIndex <= currentStepIndex ? "100%" : "0%");

  // Add handleStepClick function if onStepClick is true and we decide to add this functionality (see ticket)

  return (
    <>
      <Spacer size="md-lg" />
      <nav aria-label="Signup progress">
        <ol className="flex w-full gap-2 max-w-xl mx-auto">
          { steps.map((step, index) => {
            const isCurrent = index === currentStepIndex;
            return (
              <li
                key={`progress-${step.label}`}
                className="flex flex-1 flex-col text-center"
                aria-current={isCurrent ? "step" : undefined}
              >
                { !hideLabels && (
                  <TextSubtitle tag="span" size={2} align="center" className="uppercase px-1 mb-2">
                    { step.label }
                  </TextSubtitle>
                ) }
                <div
                  className="h-2 w-full bg-light-grey rounded-full"
                  role="progressbar"
                  aria-valuenow={index <= currentStepIndex ? 100 : 0}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={`Step ${index + 1} of ${steps.length}${isCurrent ? ", current step" : ""}`}
                >
                  <div
                    // I have asked YuXin if we want to keep the transition effect
                    className={"h-full transition-all ease-in-out duration-300 rounded-full bg-brand"}
                    style={{ width: getProgress(index) }}
                    data-testid="progress-step"
                  />
                </div>
              </li>
            );
          }) }
        </ol>
      </nav>
      <Spacer size="md-lg" />
    </>
  );
};
